import { render, staticRenderFns } from "./SynchronizationProposalBanner.vue?vue&type=template&id=369b0a2a&scoped=true"
import script from "./SynchronizationProposalBanner.vue?vue&type=script&lang=ts"
export * from "./SynchronizationProposalBanner.vue?vue&type=script&lang=ts"
import style0 from "./SynchronizationProposalBanner.vue?vue&type=style&index=0&id=369b0a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b0a2a",
  null
  
)

export default component.exports